import common from "./common";
import components from "./components";
import pages from "./pages";

export default {
  common,
  components,
  pages,
};
